import { motion } from "framer-motion";
import { Armchair, BadgeCheck, Calendar, Clock, MapPin, MessageCircle } from "lucide-react";
import { Button } from "../ui/button";

const DETAILS = [
  { Icon: Calendar, label: "Date", value: "Sunday, 15 November 2026" },
  { Icon: Clock, label: "Time", value: "12:00 PM" },
  { Icon: MapPin, label: "Venue", value: "Kuala Lumpur", sub: "(lokasi penuh akan dimaklumkan)" },
];

const STEPS = [
  {
    num: "01",
    title: "CHOOSE YOUR SEAT",
    desc: "Pilih DIAMOND, GOLD atau SILVER mengikut pengalaman yang anda inginkan.",
    Icon: Armchair,
  },
  {
    num: "02",
    title: "CONTACT OUR ADMIN",
    desc: "Hubungi admin rasmi untuk mendapatkan panduan deposit trading dan pengesahan kelayakan.",
    Icon: MessageCircle,
  },
  {
    num: "03",
    title: "CONFIRM YOUR REGISTRATION",
    desc: "Setelah deposit disahkan, admin akan membantu pengesahan seat dan memberikan maklumat kehadiran event.",
    Icon: BadgeCheck,
  },
];

export const EventDetails = ({ onReserve }) => (
  <section
    id="event-details"
    data-testid="event-details-section"
    className="border-y border-white/5 bg-fira-panel py-24 md:py-32"
  >
    <div className="mx-auto max-w-6xl px-5">
      <div className="text-center">
        <span className="eyebrow">
          Event Details
        </span>
        <h2 className="font-display mt-4 text-4xl font-semibold md:text-5xl">
          The New Era — <span className="italic text-fira-rose">Official Event</span>
        </h2>
      </div>
      <div className="mx-auto mt-12 grid max-w-4xl gap-5 sm:grid-cols-3" data-testid="event-info-grid">
        {DETAILS.map(({ Icon, label, value, sub }, i) => (
          <motion.div
            key={label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            data-testid={`event-info-${label.toLowerCase()}`}
            className="flex flex-col items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-6 py-8 text-center"
          >
            <div className="pink-glow flex h-12 w-12 items-center justify-center rounded-full bg-fira-pink">
              <Icon className="h-5 w-5 text-white" />
            </div>
            <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-fira-rose">
              {label}
            </span>
            <span className="text-sm font-semibold text-white">{value}</span>
            {sub && <span className="text-xs text-white/50">{sub}</span>}
          </motion.div>
        ))}
      </div>
      <h3 className="mt-20 text-center text-sm font-bold uppercase tracking-[0.3em] text-white">
        How To Secure Your Seat
      </h3>
      <div className="relative mt-14" data-testid="steps-grid">
        <div className="absolute left-[16%] right-[16%] top-8 hidden h-px bg-gradient-to-r from-fira-pink/60 via-fira-gold/60 to-fira-pink/60 md:block" />
        <div className="grid gap-10 md:grid-cols-3">
          {STEPS.map(({ num, title, desc, Icon }, i) => (
            <motion.div
              key={num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              data-testid={`step-${num}`}
              className="relative flex flex-col items-center text-center"
            >
              <div className="pink-glow relative z-10 flex h-16 w-16 items-center justify-center rounded-full border border-fira-pink/50 bg-fira-deep">
                <Icon className="h-6 w-6 text-fira-rose" />
                <span className="absolute -right-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full bg-fira-pink text-[11px] font-bold text-white">
                  {num}
                </span>
              </div>
              <div className="mt-6 w-full rounded-2xl border border-white/10 bg-white/5 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-fira-pink/40">
                <h4 className="text-sm font-bold tracking-wider text-white">
                  STEP {num} — {title}
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-white/60">{desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="mt-12 flex justify-center">
        <Button
          onClick={onReserve}
          data-testid="event-details-cta-btn"
          className="btn-lux rounded-full px-10 py-6 text-sm font-bold tracking-widest text-white transition-all duration-300 hover:scale-105"
        >
          <MessageCircle className="mr-2 h-5 w-5" />
          CONTACT ADMIN NOW
        </Button>
      </div>
    </div>
  </section>
);
